/**
 * @file Is an overall container for the whole child app.
 */
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { ref } from 'valtio';
import { useEffectOnce } from 'usehooks-ts';
import { useTheme } from '@mui/material/styles';
import { uiState } from '../state';
import { useLargeScreen } from '../hooks';

SubAppContainer.propTypes = {
  children: PropTypes.any,
  fullHeight: PropTypes.bool,
  sx: PropTypes.object,
  position: PropTypes.string,
};

export default function SubAppContainer({
  children,
  fullHeight = false,
  sx = {},
  position = null,
}) {
  const outRef = useRef(null);
  const inRef = useRef(null);
  const largeScreen = useLargeScreen();
  const theme = useTheme();

  useEffectOnce(() => {
    if ((uiState.outputRef === null || uiState.outputRef.current === null) && outRef !== null) {
      uiState.outputRef = ref(outRef);
    }
    if ((uiState.inputRef === null || uiState.inputRef.current === null) && inRef !== null) {
      uiState.inputRef = ref(inRef);
    }
  }, [outRef, inRef]);

  const isBottomRef = !largeScreen && position === 'bottom' ? { ref: outRef } : null;
  const isRightRef = largeScreen && position === 'right' ? { ref: outRef } : null;
  const isTopRef = !largeScreen && position === 'top' ? { ref: inRef } : null;
  return (
    <Container
      className="disable-text-selection"
      sx={{ height: fullHeight ? theme.custom.preferredHeight : '100%', ...sx }}
      {...isBottomRef}
      {...isRightRef}
      {...isTopRef}
    >
      <Grid container spacing={0} sx={{ height: fullHeight ? theme.preferredHeight : '100%' }}>
        {children}
      </Grid>
    </Container>
  );
}
